import { useMutation, useQueryClient } from '@tanstack/react-query';
import { postJsonForBlob } from '../client';

export type LegalDocumentKind = 'engagement_letter' | 'scope_of_work' | 'proposal';

export interface GenerateLegalDocumentInput {
  kind: LegalDocumentKind;
  project_id: number;
  effective_date: number;
  scope: string;
  fees: string;
  terms?: string;
  schedule?: string;
  client_signer_name?: string;
  sfs_signer_name?: string;
  is_confidential?: boolean;
}

export function useGenerateLegalDocument() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ kind, ...body }: GenerateLegalDocumentInput) =>
      postJsonForBlob(`/api/legal-documents/${kind}`, body),
    onSuccess: (_data, vars) => {
      void qc.invalidateQueries({
        queryKey: ['documents', { project_id: vars.project_id }],
      });
      void qc.invalidateQueries({ queryKey: ['documents'] });
    },
  });
}
